// @ts-nocheck
import { Dialog, DialogTitle } from '@mui/material';
import React, { useState } from 'react';
import { useActions } from '../../../hooks/useActions';
import { useTypedSelector } from '../../../hooks/useTypedSelector';
import { IAddEntityModalParameters } from '../../../models/AddEntityModalParameters';
import { ICreateProjectPhaseInput } from '../../../models/ICreateProjectPhaseInput';
import KanbanButton from '../../KanbanButton';
import NoPermissionDialog from '../../NoPermissionDialog';
import { checkPermission } from '../../../helpers/PermissionsHelper';
import { ERROR_MESSAGES } from '../../../models/constants';
import { usePageKey } from '../../../../shared/contexts/PageKeyContext';

export const ProjectsNewLaneSection = React.memo(() => {
  const { project, board } = useTypedSelector((state) => state.project);
  const { openProjectsModal, createProjectPhase } = useActions();
  const [isOpenMessage, setIsOpenMessage] = useState(false);
  const [duplicateMessage, setDuplicateMessage] = useState('');
  const [hasPermissionError, setHasPermissionError] = useState<string | null>(null);
  const pageKey = usePageKey();

  const onCreatePhase = (input: string) => {
    const isDuplicatePhaseName = board.lanes.some((l) => l.title === input);
    if (isDuplicatePhaseName) {
      setDuplicateMessage(`The phase with this name '${input}' already exists`);
      setIsOpenMessage(true);
      return;
    }
    const phase = {
      projectId: project.id,
      phaseName: input,
    } as ICreateProjectPhaseInput;
    createProjectPhase(phase);
  };
  const modalParameters: IAddEntityModalParameters = {
    headerPlaceholder: `Add a new phase`,
    textPlaceholder: 'Name your phase',
    addEntityButtonPlaceholder: 'Add',
    cancelEntityButtonPlaceholder: 'Cancel',
  } as IAddEntityModalParameters;

  const openModal = async () => {
    const hasPermission = await checkPermission('createPhase', pageKey);
    if (!hasPermission) {
      setHasPermissionError(ERROR_MESSAGES.CREATE_NO_PERMISSION);
      return;
    }
    openProjectsModal(modalParameters, onCreatePhase);
  };

  const handleCloseMessage = () => {
    setIsOpenMessage(false);
  };

  return hasPermissionError ? (
    <NoPermissionDialog
      isOpen={true}
      onClose={() => setHasPermissionError(null)}
      message={hasPermissionError}
    />
  ) : (
    <div style={{ minWidth: '266px' }}>
      <KanbanButton list onClick={openModal} />
      <Dialog open={isOpenMessage} onClose={handleCloseMessage}>
        <DialogTitle>{duplicateMessage}</DialogTitle>
      </Dialog>
    </div>
  );
});
